export default function Logo() {
  return <h1>PackList</h1>;
}
